import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalService } from '../../core/global.service';
import { GlobalNamespace as _GlobalNS } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../core/global.service";
var TaskSearchService = /** @class */ (function () {
    function TaskSearchService(_http, _global) {
        this._http = _http;
        this._global = _global;
        this.taskSearchResults = [];
    }
    TaskSearchService.prototype.search = function (url, crit) {
        var api = url || _GlobalNS.api.task.search;
        var heads = {};
        var headers = new HttpHeaders(heads);
        var params = crit;
        return this._http.get("" + api, { headers: headers, params: params });
    };
    TaskSearchService.prototype.getTaskViewUri = function (eventlocation, property_id, eventTrackingID, event_tracking_parent) {
        var buildUri = eventlocation + "&property_id=" + property_id + "&eventTrackingID=" + eventTrackingID;
        buildUri = (event_tracking_parent !== null) ? buildUri + "&event_tracking_parent=" + event_tracking_parent : buildUri;
        return _GlobalNS.api.baseEvent + buildUri;
    };
    TaskSearchService.prototype.exportToExcel = function (url, crit) {
        var api = url || _GlobalNS.api.task.buildExcel;
        var heads = {};
        var headers = new HttpHeaders(heads);
        var params = crit;
        return this._http.get("" + api, { headers: headers, params: params });
    };
    TaskSearchService.ngInjectableDef = i0.defineInjectable({ factory: function TaskSearchService_Factory() { return new TaskSearchService(i0.inject(i1.HttpClient), i0.inject(i2.GlobalService)); }, token: TaskSearchService, providedIn: "root" });
    return TaskSearchService;
}());
export { TaskSearchService };
